export const colors = {
  biology: '#42cdc8',
  generalChemistry: '#00a0f0',
  organicChemistry: '#eb9633',
  perceptualAbility: '#2a6df4',
  readingComprehension: '#ab3ac7',
  quantitativeReasoning: '#d3365a',
  anatomy: '#A81A56',
  pharmacology: '#EB9633',
  ethics: '#1A8B63',
  fieldsOfDentistry: '#42CDC8',
  patientManagement: '#00A0F0',
  diagnosisDisorders: '#2A6DF4',
  research: '#AB3AC7',
  operative: '#21899E',
  orthodontics: '#1C9855',
  optics: '#42B5CD',
  accent: '#A464D2',

  typographyOne: '#323b4b',
  typographyTwo: '#4e5d78',
  typographyThree: '#8a94a6',
  typographyFour: '#b0b7c3',
  typographyFive: '#ffffff',
  typographyThreeHover: '#6c798f',

  backgroundOne: '#e8e8ec',
  backgroundTwo: '#f1f1f1',
  backgroundThree: '#f9fafb',
  backgroundFour: '#ffffff',
  backgroundFive: '#f6f6f7',
  backgroundSix: '#d4d8de',

  blue: '#2489ff',
  green: '#0dcb86',
  yellow: '#ffc149',
  red: '#ff555f',
  gray: '#6e7a90',

  blueHover: '#3f98ff',
  greenHover: '#0fd78f',
  yellowHover: '#e3ad45',
  redHover: '#ff6a73',
  grayHover: '#f6f6f7',

  blueActive: '#257de4',
  greenActive: '#0bb87a',
  redActive: '#e25059',
  grayActive: '#6e7a90',

  white: '#ffffff',
  black: '#000000',
  empty: '#00000000',

  java: '#18bed4',
}
